{
  "0629f48c230e746d": "Give Feedback",
  "10d20e340181a52f": "Select all that apply",
  "11de3b88286c6167": "Which qualities could they improve on?",
  "12684ec2f0c1ea65": "Review Professionals",
  "1509f561f2416598": "Save",
  "155f816c0407310c": "Submit",
  "2875c4ffca926cfb": "This professional and other workplaces",
  "2b6c74d8b1f2fd14": "Share why you're endorsing this professional",
  "32352fe744363d05": "Skills Review",
  "36ba03a5676c2c15": "Add a warning for {{skill}} (currently flagged)",
  "410fb8b9a6a0b173": "Who can see this feedback?",
  "47848513d9d5a830": "Endorse {{skill}}",
  "4949b7599fc3e7be": "View {{skill}} endorsements",
  "4d2eedf2048bec29": "Unable to load endorsement details.",
  "4ecd112119e2d8fa": "You previously submitted a warning to {{name}} for {{skill}}. Endorsing will replace that warning.",
  "5948473cb85291e6": "Toggle endorsements",
  "62e4c6f38c6d4e89": "Share why you might block this professional if they don't improve",
  "6a1eda5ea53dc272": "Issue warning",
  "6b86e3ccbcad816b": "This professional only",
  "7c0156bbe423568e": "Close endorsements",
  "8275b5b6b1fa4e4d": "Next professional",
  "94ea9b1d33a02975": "Show less",
  "951ccd104d51268a": "Which competencies did they demonstrate?",
  "9d716e7380171a24": "this quality",
  "a0c53db263f84bf3": "View {{skill}} endorsement details",
  "a41bf8ada0416399": "Endorse professional",
  "a487060ccc02d84a": "Add a warning for {{skill}}",
  "aac77df347205252": "Feedback",
  "aafe8bfcc0578c11": "Your feedback goes straight to the professional. Let them know how they're doing.",
  "b44001c59be87364": "This professional doesn't have any feedback for this quality yet.",
  "d471b71ef926577f": "Endorsements",
  "d7a8974566f771f1": "No options",
  "d97ab656951b5218": "This feedback will go directly to the professional",
  "e4ff36b0fe818fd7": "Skip, I'm not familiar",
  "e981ddae45d8f4ca": "Warning",
  "ec6eae07be163c87": "Endorse {{skill}} (currently endorsed)",
  "efb33072f8e44823": "Previous professional",
  "f47e536b520c96a7": "Endorsement",
  "f5c9bd131486e793": "Show more",
  "fb38cbfcfc5f7f62": "You previously submitted a {{skill}} endorsement for {{name}}. A warning will replace that endorsement.",
  "fd5ca43ef5f13cca": "Failed to submit feedback. Please try again."
}
